var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({tag:"Component",class:[ _vm.computedClasses ].concat( _vm.c_font ),style:(_vm.computedStyles)},'Component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }